import React, { Component, useState, useEffect, useContext } from "react";
import { alert_error, alert_success } from '../../../AppContext';
import AdSense from 'react-adsense';
import { useParams, useLocation } from 'react-router-dom';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Cookies } from '../../../index.js';
import { Helmet } from "react-helmet";
import StatusBadge from "../../../js/buttonstatus.jsx";
import { ClipLoader, PulseLoader } from 'react-spinners';
import axios from "axios";
import queryString from 'query-string';
import ToggleButton from '../../../app_structure/toggleButton';
import Banner from '../../../Banner';
import Bannerprofile from '../../../shop/ads/Bannerprofile.jsx';
import AudioHistory from './audio.jsx';

function Nhatkyorders(props) {
    const [nutxuly, setnutxuly] = useState(0);
    const [hiendanhsach, sethiendanhsach] = useState(true);
    // Lấy đường dẫn hiện tại
    const currentPath = window.location.pathname;
    const { slug_2 } = useParams();
    // Tách lấy phần cuối cùng của đường dẫn
    const parts = currentPath.split('/');
    const duongdan = parts[parts.length - 1];
    const [buttonTextjop, setbuttonTextjop] = useState("Xác nhận");
    const [timkiem, settimkiem] = useState(false);
    const [inputlienket, setinputlienket] = useState('');
    const [chedo, setchedo] = useState('');
    const options = [
        { text: 'Chọn 1 chế độ tìm kiếm', value: '' },
        { text: 'Tìm theo liên kết', value: 'getlienket' },
        { text: 'Tìm theo id', value: 'getid' }
    ];

    function saochep(value) {
        alert_success('Đã sao chép');
        window.saochepnative(value);

    };
    function handleToggle(isOn) {
        if (isOn) {
            settimkiem(true);
        } else {
            settimkiem(false);
            sethiendanhsach(true);
        }
    }

    function testFunction(response) {
        if (response.data != '') {
            setnutxuly(0);
            setbuttonTextjop('xác nhận');
            setdulieudonhang(response.data);
            setbuttonloadlist(false);
            settimkiem(false);
            sethiendanhsach(false);
        }
        else {
            setnutxuly(0);
            setbuttonTextjop('xác nhận');
            alert_error('Không tìm thấy dữ liệu');
        }
    };
    function handleSubmit(event) {
        const myCookieValue = Cookies.get('apikey');
        event.preventDefault();
        setnutxuly(1);
        setbuttonTextjop('Please wait a moment 😊');
        if (!inputlienket || !chedo) {
            alert('Please điền đầy đủ thông tin')
            setnutxuly(0);
            setbuttonTextjop('điền đủ thông tin');
            return
        }
        else {

            axios.get(
                'https://hust.media/api/wallet/history.php?' + chedo + '=' + inputlienket + '&apikey=' + myCookieValue)
                .then(response => (testFunction(response)))
                .catch(error => console.log(error))

        }

    }
    const [buttonloadlist, setbuttonloadlist] = useState(true);
    const categoryValue = props?.category || slug_2;
    const totalPages = 5; // tổng số trang
    const values = queryString.parse(window.location.search);
    const currentPagephu = values.listtrang
    const [currentPage, setcurrentPage] = useState(1);
    // tạo một mảng chứa các số trang từ 1 đến totalPages
    const [pageNumbers, setpageNumbers] = useState(Array.from({ length: totalPages }, (_, i) => i + 1));

    const [dulieudonhang, setdulieudonhang] = useState([
        {
            id: 1,
            start_count: 100,
            remains: 50,
            service_name: "Đang tải danh sách vui lòng đợi",
            url: "Đang tải danh sách vui lòng đợi",
            amount: 10,
            money: 100,
            note: "Note 1",
            updatedate: "2023-04-05",
        }
        // Thêm dữ liệu vào đây
    ]);
    const laynhatky = async () => {
        const myCookieValue = Cookies.get('apikey');
        const values = queryString.parse(window.location.search);
        const listtrang = values.listtrang || 1;

        setcurrentPage(values.listtrang);


        try {
            const response = await axios.get('https://hust.media/truyenthanh/ai/history.php?listtrang=' + listtrang + '&apikey=' + myCookieValue + '&category=' + categoryValue);
            if (response.data != '') {
                setdulieudonhang(response.data);
                setbuttonloadlist(false);
            }


        } catch (error) {

        }
    };

    const location = useLocation();
    useEffect(() => {
        setbuttonloadlist(true);
        // Xử lý sự kiện khi location thay đổi, ví dụ:
        console.log('Đã thay đổi đường dẫn:', location.pathname);
        laynhatky();
    }, [location]);

    // render component

    return (
        <>
            <Banner />


            <div className="max-h-16">
                <div className="cards">
                    <AdSense.Google
                        client="ca-pub-4574266110812955"
                        slot="1627514116"
                        style={{ display: 'block' }}
                        format='horizontal'
                        responsive='false'
                    /></div>
            </div>

            {/* {duongdan} */}

            {timkiem ? (<>   <form className="add-form">

                <div className="form-control">
                    <select
                        id="countries2"
                        className="selectpicker sp1 form-control"
                        onChange={(e) => setchedo(e.target.value)}
                    >
                        {options.map((option) => (
                            <option key={option.value}
                                value={option.value}>
                                {option.text}
                            </option>
                        ))}
                    </select>
                    <label>Nhập cần tìm kiếm</label>
                    <br />
                    <div className="input-group flex-nowrap">
                        <span className="input-group-text" id="addon-wrapping">
                            Search
                        </span>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Điền từ khóa"
                            aria-label="inputlienket"
                            value={inputlienket}
                            name="inputlienket"
                            aria-describedby="addon-wrapping"
                            onChange={e => setinputlienket(e.target.value)}
                        />
                    </div>

                </div>

                <br></br>
                <button onClick={handleSubmit}
                    className='flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 w-full dark:bg-slate-800 dark:text-white'>
                    <div className='flex items-center justify-between flex-1'>
                        {nutxuly == 1 && (
                            <div className="spinner-border" role="status">

                            </div>
                        )}


                        <span className='text-lg font-medium text-white'>
                            {buttonTextjop} </span>
                        <div className="text-xl">
                            {'\u27A4'}
                        </div>
                    </div>
                </button>

            </form></>) : (<>

                <div className="container-fluid mt--9">

                    <div className="row">

                        <div className="col-xl-12 order-xl-2 mb-5 mb-xl-0">
                            {dulieudonhang === 'empty' && !buttonloadlist ? (

                                <>
                                    <div className="table-responsive overflow-x-hidden">
                                        <div className="text-center text-2xl mt-3">
                                            📦 Danh sách đơn hàng trống rỗng, chưa có thông tin nào 📭
                                        </div>
                                    </div>
                                </>
                            ) : (
                                buttonloadlist ? (
                                    <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
                                        <ClipLoader color="#fff" size={150} />
                                    </div>
                                ) : (<div className="table-responsive overflow-x-hidden">
                                    <table className="table align-middle table-flush table-sm table-bordered">
                                        <thead className="thead-light" >
                                            <tr>
                                                <th className="text-lowercase text-center" style={{ width: "7%" }} scope="row">
                                                    mã đơn hàng
                                                </th>
                                                <th className="text-center" style={{ width: "15%" }} scope="row">
                                                    DỊCH VỤ
                                                </th>
                                                <th className="text-center" style={{ width: "15%" }} scope="row">
                                                    status
                                                </th>
                                                <th className="text-lowercase text-center" style={{ width: "40%" }} scope="col">
                                                    link
                                                </th>
                                                <th className="text-center" style={{ width: "10%" }} scope="row">
                                                    Mô tả
                                                </th>
                                                <th className="text-center" style={{ width: "10%" }} scope="col">
                                                    THỜI GIAN
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dulieudonhang.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="text-center">
                                                        <p onClick={() => saochep(item.id)} className="text-sm break-all">{item.id}</p>
                                                    </td>
                                                    <td className="text-center">
                                                        <span className="inline-block text-sm font-bold text-white  px-1 py-1 
                                                        break-all  bg-danger  rounded-pill text-wrap">
                                                            <b className="text-white">{item.service_name}</b>
                                                        </span>
                                                    </td>
                                                    <td className="text-center">
                                                        <StatusBadge status={item.status}/>
                                                    </td>
                                                    <td className="text-center justify-center flex">
                                                        {(slug_2 === 'image_vip' || slug_2 === 'image_face') ? (
                                                            <>
                                                                <a
                                                                    href={`${item.url}`}
                                                                    download
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="inline-block"
                                                                >
                                                                    <img
                                                                        src={`${item.url}`}
                                                                        alt="VIP"
                                                                        className="max-w-full h-auto rounded-lg border"
                                                                    />
                                                                    <button
                                                                        className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 mt-2 px-4 rounded"
                                                                    >
                                                                        Tải ảnh
                                                                    </button>
                                                                </a>
                                                            </>
                                                        ) : slug_2 === 'text_speech' ? (
                                                            <>
                                                                <AudioHistory storageLocation={item.storage_location} />
                                                            </>
                                                        ) : slug_2 === 'speech_text' ? (
                                                            <>
                                                                <AudioHistory
                                                                    storageLocation={item.storage_location}
                                                                    baseUrl="https://hust.media"
                                                                    textUrl={`https://hust.media/${item.storage_location}`}
                                                                    saochep={saochep}
                                                                />
                                                            </>
                                                        ) : (
                                                            <span className="text-center inline-block text-sm font-bold text-white  px-1 py-1 
                                                            break-all  bg-danger  rounded-pill text-wrap">
                                                                <b className="text-white">{item.url}</b>
                                                            </span>
                                                        )}

                                                    </td>

                                                    <td className="text-center">
                                                        <b style={{ color: "red" }}>{item.money}</b> Coins
                                                        <br />
                                                        <div style={{ width: "100%" }} className="text-lowercase text-xs text-wrap">
                                                            {item.url}
                                                        </div>
                                                    </td>
                                                    <td className="text-center">
                                                        <div style={{ width: "100%" }} className="break-all text-lowercase text-wrap">
                                                            {item.createdate}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>)

                            )
                            }

                        </div>
                    </div></div>
            </>)}

        </>
    );
};

export default Nhatkyorders;
